import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { HomegrownBanner } from '../homegrown-banner/homegrown-banner';
import { CustomersCount } from '../customers-count/customers-count';

interface FooterLink { label: string; path: string; }

@Component({
  selector: 'app-site-footer',
  imports: [CommonModule, RouterLink, HomegrownBanner, CustomersCount],
  templateUrl: './site-footer.html',
  styleUrl: './site-footer.scss',
})
export class SiteFooter {
  whoWeAreOpen = false;

  needHelp: FooterLink[] = [
    { label: 'Contact Us',        path: '/contact-us'        },
    { label: 'Track Order',       path: '/track-order'       },
    { label: 'Returns & Refunds', path: '/faqs'              },
    { label: 'FAQs',              path: '/faqs'              },
    { label: 'My Account',        path: '/my-account'        },
  ];
  company: FooterLink[] = [
    { label: 'About Us',                path: '/about-us'           },
    // { label: 'Investor Relation',       path: '/investor-relations' },
    { label: 'Careers',                 path: '/careers'            },
    { label: 'Gift Vouchers',           path: '/gift-voucher'       },
  ];
  moreInfo: FooterLink[] = [
    { label: 'T&C',           path: '/terms-and-conditions' },
    { label: 'Privacy Policy',path: '/privacy-policy'       },
    { label: 'Sitemap',       path: '/sitemap'              },
    { label: 'Get Notified',  path: '/get-notified'         },
  ];
  stores: FooterLink[] = [
    { label: 'Mumbai',    path: '/stores-near-me' },
    { label: 'Pune',      path: '/stores-near-me' },
    { label: 'Bangalore', path: '/stores-near-me' },
    { label: 'Ahmedabad', path: '/stores-near-me' },
  ];

  // Shipping-partner logos (TSS's own hosted icons, same set/order as the live footer)
  shippingLogos = [
    { alt: 'DTDC',         src: 'https://sava-s3.in-maa-1.linodeobjects.com/mmtees-dev/marketing/icons/dtdc.png' },
    { alt: 'Delhivery',    src: 'https://sava-s3.in-maa-1.linodeobjects.com/mmtees-dev/marketing/icons/delivery.png' },
    { alt: 'Ecom Express', src: 'https://sava-s3.in-maa-1.linodeobjects.com/mmtees-dev/marketing/icons/ECOM-Express.png' },
    { alt: 'XpressBees',   src: 'https://sava-s3.in-maa-1.linodeobjects.com/mmtees-dev/marketing/icons/XPRESSBEES.png' },
  ];
}
